import * as pageStyles from '../../styles/internal-page/internal-page.module.scss';
import PropTypes from 'prop-types';
import ActionElement from '../shared/ActionElement';
import PolyLink from '../shared/PolyLink';
import React from 'react';
import {useTranslation} from 'react-i18next';


const MarketingButton = ({
  actionElement,
  secondActionElement,
  knowMore,
  onclick,
  mobile,
}) => {

  const {t} = useTranslation();

  const getAriaLabelButtonAttribute = (actionElement) => {
    const msg = [];
    if (actionElement?.icon ==='DOWNLOAD') {
      msg.push(t('marketing.button.action.download', {
        document: actionElement?.label,
      }));
    } else {
      msg.push(t('marketing.button.action.url'));
      if (actionElement?.new_window) {
        msg.push(t('marketing.button.action.new-window'));
      }
    }
    return msg.join(' ');
  };


  const getKnowMoreAriaLabel = (knowMore) => {
    return t('marketing.button.action.view', {
      document: knowMore
    });
  };

  if (!actionElement) {
    return null;
  }

  const actionElementParse = (actionElement.related_contents) ?
    actionElement.related_contents[0].content[0] : actionElement;
  return (
    <ActionElement mobile={mobile}>
      <div className={pageStyles.marketingButtonWidth}>
        {actionElementParse?.__typename ===
          'CmsPortalComponentWidgetActionElement' && (
          <div
            className={pageStyles.compsFlex}
            style={{flexBasis: knowMore || secondActionElement ? '50%' : '100%'}}
          >
            <button
              aria-label={getAriaLabelButtonAttribute(actionElementParse)}
              className={pageStyles.darkButton}
              tabIndex="0"
            >
              <PolyLink
                ariaLabel={actionElementParse?.label}
                target="_blank"
                url={actionElementParse?.URL}
              >
                <p className={pageStyles.labelButton}>
                  {actionElementParse?.label}
                </p>
              </PolyLink>
            </button>
          </div>
        )}
        {secondActionElement?.__typename ===
          'CmsPortalComponentWidgetActionElement' && (
          <div
            className={pageStyles.compsFlex}
            style={{flexBasis: '50%'}}
          >
            <button
              aria-label={getAriaLabelButtonAttribute(secondActionElement)}
              className={pageStyles.redButton}
              tabIndex="0"
            >
              <PolyLink
                ariaLabel={secondActionElement?.label}
                target="_blank"
                url={secondActionElement?.URL}
              >
                <p className={pageStyles.labelButton}>
                  {secondActionElement?.label}
                </p>
              </PolyLink>
            </button>
          </div>
        )}
        {knowMore && (
          <div
            className={pageStyles.compsFlex}
            style={{flexBasis:
              actionElementParse?.__typename ===
              'CmsPortalComponentWidgetActionElement'
                ? '50%'
                : '100%'
            }}
          >
            <button aria-label={getKnowMoreAriaLabel(knowMore)}
              className={pageStyles.redButton}
              onClick={onclick}
              tabIndex="0"
            >
              <p className={pageStyles.labelButton}>
                {knowMore}
              </p>
            </button>
          </div>
        )}
      </div>
    </ActionElement>
  );
};

MarketingButton.propTypes = {
  actionElement: PropTypes.shape({
    __typename: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    new_window: PropTypes.bool,
    URL: PropTypes.string,
    related_contents: PropTypes.arrayOf(
      PropTypes.shape({
        content: PropTypes.array.isRequired,
      })
    ),
  }),
  knowMore: PropTypes.string,
  mobile: PropTypes.bool,
  onclick: PropTypes.func,
  secondActionElement: PropTypes.shape({
    __typename: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    new_window: PropTypes.bool,
    URL: PropTypes.string,
  }),
};

export default MarketingButton;
